import { inject, Injectable, signal } from '@angular/core';
import { ExtractedLocationData } from '../../models/interfaces';
import { getTableRowRect } from '../../table-overlay/table-overlay';
import { TableOverlayStoreService } from './table-overlay-store.service';
import { ExtractedLocationStoreService } from './extracted-location-store.service';

@Injectable({
  providedIn: 'root',
})
export class OcrHighlightService {
  private readonly extractedLocationStoreService = inject(ExtractedLocationStoreService);
  private readonly tableOverlayStoreService = inject(TableOverlayStoreService);

  private readonly _fieldHighlight = signal<ExtractedLocationData | undefined>(undefined);

  highlight = this._fieldHighlight.asReadonly();

  setTableRowHighlight(tableId: string, rowIndex: number) {
    const table = this.tableOverlayStoreService.getTableById(tableId);
    const rowRect = getTableRowRect(table, rowIndex);
    this._fieldHighlight.set({
      pageId: table.pageId,
      selection: [[rowRect]],
    });
  }

  setFieldHighlight(documentId: string, field: string): ExtractedLocationData | undefined {
    const extractedFieldLocation = this.extractedLocationStoreService.getExtractedLocation(
      documentId,
      field,
    );
    this._fieldHighlight.set(extractedFieldLocation);
    return extractedFieldLocation;
  }

  clearHighlight() {
    this._fieldHighlight.set(undefined);
  }
}
